<section class="booking" [id]="booking.id">
  <div class="container">
    <div class="section-header">
      <span class="subtitle">{{ booking.subtitle }}</span>
      <h2>{{ booking.title }}</h2>
      <p>{{ booking.description }}</p>
    </div>

    <div class="booking-content">
      <div class="booking-form">
        <h3>{{ booking.detailsTitle }}</h3>
        <p>{{ booking.detailsDescription }}</p>

        <form [formGroup]="bookingForm" (ngSubmit)="submitBooking()">
          <div class="form-grid">
            @for (field of sortedFields; track $index) {
            @if (isFieldVisible(field)) {
            <div class="form-field" [style]="getFieldGridStyles(field)">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ field.label }}</mat-label>

                @switch (field.type) {
                @case ('textarea') {
                <textarea matInput [id]="field.name" [formControlName]="field.name"
                  [placeholder]="field.placeholder || ''" [rows]="field.rows || 4"></textarea>
                }
                @case ('select') {
                <mat-select [id]="field.name" [formControlName]="field.name" [multiple]="!!field.multiple">
                  <!--add "required" to make it required -->
                  @for (option of getFieldOptions(field); track $index) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                  }
                </mat-select>
                }
                @case ('date') {
                <ng-container>
                  <input matInput [matDatepicker]="picker" [formControlName]="field.name"
                    [min]="getMinDate(field.validation?.moreThan)" [max]="getMaxDate(field.validation?.lessThan)" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </ng-container>
                }
                @case ('checkbox') {
                <mat-checkbox [id]="field.name" [formControlName]="field.name">{{
                  field.label
                  }}</mat-checkbox>
                @if (hasError(field, 'required')) {
                <div class="error-message">
                  {{ getErrorMessage(field, 'required') }}
                </div>
                }
                }
                @case ('radio') {
                <span class="field-label">{{ field.label }}</span>
                <mat-radio-group [id]="field.name" [formControlName]="field.name" class="radio-group">
                  @for (option of field.options; track $index) {
                  <mat-radio-button [value]="option.value">{{
                    option.label
                    }}</mat-radio-button>
                  }
                </mat-radio-group>
                @if (hasError(field, 'required')) {
                <div class="error-message">
                  {{ getErrorMessage(field, 'required') }}
                </div>
                }
                }
                @default {
                <input matInput [id]="field.name" [type]="field.type" [formControlName]="field.name"
                  [placeholder]="field.placeholder || ''" />
                }
                }

                @if (hasError(field, 'required')) {
                <mat-error>{{ getErrorMessage(field, 'required') }}</mat-error>
                }
                @if (hasError(field, 'email')) {
                <mat-error>{{ getErrorMessage(field, 'email') }}</mat-error>
                }
                @if (hasError(field, 'minlength')) {
                <mat-error>{{ getErrorMessage(field, 'minLength') }}</mat-error>
                }
                @if (hasError(field, 'maxlength')) {
                <mat-error>{{ getErrorMessage(field, 'maxLength') }}</mat-error>
                }
                @if (hasError(field, 'pattern')) {
                <mat-error>{{ getErrorMessage(field, 'pattern') }}</mat-error>
                }
                @if (hasError(field, 'arrivalPast')) {
                <mat-error>{{ getErrorMessage(field, 'arrivalPast') }}</mat-error>
                }
                @if (hasError(field, 'departurePast')) {
                <mat-error>{{ getErrorMessage(field, 'departurePast') }}</mat-error>
                }
                @if (hasError(field, 'departureBeforeArrival')) {
                <mat-error>{{ getErrorMessage(field, 'departureBeforeArrival') }}</mat-error>
                }
              </mat-form-field>
            </div>
            }
            }
          </div>

          <button type="submit" class="primary-btn">{{ booking.submitButtonText }}</button>
        </form>
      </div>
    </div>
  </div>
</section>
